








import {Component, Prop, Vue} from 'vue-property-decorator';
@Component({
    components: {},
})
export default class CoinTitle extends Vue {
    @Prop()public coins!: string;
    constructor() {
        super();
    }
}
